'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _class2, _temp;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

require('./view.less');

var _service = require('./service');

var _lodash = require('lodash');

var _next = require('@alifd/next');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _vuFusionField = require('../common/vu-fusion-field');

var _vuFusionField2 = _interopRequireDefault(_vuFusionField);

var _formFieldUtils = require('../common/formFieldUtils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

var RadioGroup = _next.Radio.Group;

var list = [{
  value: 'macao',
  label: '澳门地区'
}, {
  value: 'mainland',
  label: '非澳门地区'
}];
var listMap = {
  macao: '澳门地区',
  mainland: '非澳门地区'
};

var ControlApp = function (_React$Component) {
  _inherits(ControlApp, _React$Component);

  // 刚开始不熟，现在回头看好乱好傻的代码。。。。
  function ControlApp(props) {
    _classCallCheck(this, ControlApp);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    _this.onChange = _this.onChange.bind(_this);
    return _this;
  }

  ControlApp.prototype.onChange = function onChange(value) {
    this.props.onChangeArea({ value: value });
  };

  ControlApp.prototype.render = function render() {
    var props = this.props.props;
    var behavior = props.behavior;

    return behavior === 'READONLY' ? _react2.default.createElement(
      'div',
      { className: 'vc-form-item-view' },
      _react2.default.createElement(
        'span',
        { className: 'vc-form-item-view-text', title: listMap[props.area] },
        (0, _lodash.isNil)(listMap[props.area]) ? _formFieldUtils.EMPTY_TEXT : listMap[props.area]
      )
    ) : _react2.default.createElement(RadioGroup, { dataSource: list, value: props.area, onChange: this.onChange });
    // return <RadioGroup dataSource={list} value={props.area} onChange={this.onChange} />;
  };

  return ControlApp;
}(_react2.default.Component);

var AutoComplete = _next.Select.AutoComplete;

var AddressSelect = function (_React$Component2) {
  _inherits(AddressSelect, _React$Component2);

  function AddressSelect(props, context) {
    _classCallCheck(this, AddressSelect);

    var _this2 = _possibleConstructorReturn(this, _React$Component2.call(this, props, context));

    _this2.fetchData = function () {
      var address = _this2.props.props.address;

      return (0, _service.pageQuery)({ key: address }).then(function () {
        var res = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        var dataSource = res.map(function (item) {
          return {
            label: item.building.name,
            value: item.building.name,
            secondaryLocation: '' + item.parish.name + item.street.name
          };
        });
        _this2.setState({ dataSource: dataSource });
      });
    };

    _this2.handleChange = function (value, actionType, item) {
      clearTimeout(_this2.searchTimeout);
      // this.setState({ address: value });
      if (actionType === 'itemClick' || actionType === 'enter') {
        _this2.props.onSelectAdrress({ secondaryLocation: item.secondaryLocation, address: value, hasSelect: true });
      } else {
        _this2.props.onSelectAdrress({ secondaryLocation: '', address: value, hasSelect: false });
      }
      _this2.searchTimeout = setTimeout(function () {
        // eslint-disable-next-line handle-callback-err
        _this2.fetchData();
      }, 100);
    };

    _this2.state = {
      dataSource: []
    };
    _this2.fetchData = (0, _lodash.debounce)(_this2.fetchData.bind(_this2), 200);
    return _this2;
  }
  /**加载下拉框数据*/


  AddressSelect.prototype.render = function render() {
    return _react2.default.createElement(
      _react.Fragment,
      null,
      _react2.default.createElement(AutoComplete, {
        filterLocal: false,
        placeholder: '\u53EF\u641C\u7D22\u5730\u5740',
        onChange: this.handleChange,
        value: this.props.props.address,
        dataSource: this.state.dataSource,
        hasClear: true
      })
    );
  };

  return AddressSelect;
}(_react2.default.Component);

var AddressSelectMacao = function (_React$Component3) {
  _inherits(AddressSelectMacao, _React$Component3);

  function AddressSelectMacao(props) {
    _classCallCheck(this, AddressSelectMacao);

    var _this3 = _possibleConstructorReturn(this, _React$Component3.call(this, props));

    _this3.detailChange = _this3.detailChange.bind(_this3);
    _this3.onSelectAdrress = _this3.onSelectAdrress.bind(_this3);
    return _this3;
  }

  AddressSelectMacao.prototype.detailChange = function detailChange(type, value) {
    this.props.onEditData({ type: type, value: value });
  };

  AddressSelectMacao.prototype.onSelectAdrress = function onSelectAdrress() {
    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    this.props.onSelectAdrress(value);
  };

  AddressSelectMacao.prototype.render = function render() {
    var _this4 = this;

    var props = this.props.props;
    var addressProps = props;
    if (props && props.style && props.style.maxWidth) {
      addressProps.style.width = props.style.maxWidth;
    }
    var addressArea = props.addressArea,
        addressDetail = props.addressDetail;

    return _react2.default.createElement(
      _react.Fragment,
      null,
      _react2.default.createElement(
        _next.Grid.Row,
        { gutter: '4' },
        _react2.default.createElement(
          _next.Form.Item,
          _extends({
            className: 'next-form-address-text'
          }, _extends({}, addressProps, {
            required: addressArea ? props.required : false,
            label: addressArea ? addressArea : ' '
          })),
          _react2.default.createElement(AddressSelect, { props: addressProps, onSelectAdrress: this.onSelectAdrress })
        ),
        _react2.default.createElement(
          _next.Form.Item,
          { className: 'next-form-address-text vc-form-item', hidden: !props.hasSelect },
          _react2.default.createElement(
            'p',
            { className: 'next-form-text-align' },
            _react2.default.createElement(
              'svg',
              {
                'class': 'next-form-icon',
                width: '16px',
                height: '16px',
                viewBox: '0 0 1024 1024',
                version: '1.1',
                xmlns: 'http://www.w3.org/2000/svg'
              },
              _react2.default.createElement('path', {
                fill: '#333333',
                d: 'M512 231.1c30.9 0 60 12.1 81.9 33.9 21.9 21.9 33.9 50.9 33.9 81.8s-12.1 60-33.9 81.8c-21.9 22-50.9 34.1-81.9 34.1-30.9 0-60-12.1-81.8-33.9-21.9-21.9-33.9-50.9-33.9-81.8s12.1-60 33.9-81.8c21.9-22 51-34.1 81.8-34.1m0-63.9c-99.2 0-179.7 80.5-179.7 179.7S412.9 526.6 512 526.6s179.7-80.5 179.7-179.7S611.3 167.2 512 167.2z'
              }),
              _react2.default.createElement('path', {
                fill: '#333333',
                d: 'M512 64.6c38.1 0 75.1 7.5 109.8 22.2 33.5 14.2 63.7 34.5 89.6 60.5 26 25.9 46.3 56.2 60.5 89.8 14.8 34.8 22.3 71.8 22.4 110 0.1 56.6-15.6 118.2-46.8 183-26.3 54.4-63.2 110.9-109.9 168-46.4 56.8-93.5 102.8-125.5 132.1-31.3-28.7-77.2-74-123.1-130.1-46.9-57.3-84.2-114.2-110.9-168.9-31.8-65.4-48.1-127.5-48.5-184.6-0.3-37.7 7-74.4 21.4-108.9 14-33.3 34.1-63.4 59.8-89.3 26.1-26.3 56.5-46.8 90.3-61.3 35.3-14.9 72.6-22.5 110.9-22.5m0-63.9c-191.1 0-347.5 155-346.2 346.2 2 292.5 346.2 567.7 346.2 567.7s347-275.2 346.2-567.7C857.8 155.8 703.3 0.7 512 0.7z'
              }),
              _react2.default.createElement('path', {
                fill: '#333333',
                d: 'M512.3 1022.8c-79.3 0-154.3-13.6-211.3-38.1-65.5-28.2-101.5-69.2-101.5-115.1 0-26.4 12.1-64.9 69.4-98.8 1.5-0.9 3-1.7 4.5-2.6 5.7-3.2 11.7-6.3 17.9-9.2 16-7.6 35-0.7 42.5 15.2 7.6 16 0.7 35-15.2 42.5-4.8 2.3-9.5 4.7-13.8 7.1-1.1 0.6-2.2 1.3-3.3 1.9-24.2 14.4-38 30.3-38 43.8 0 18.1 24.2 39.6 63 56.4 49.1 21.3 115.2 32.9 186 32.9s136.8-11.7 186-32.9c38.8-16.8 63-38.4 63-56.4 0-13.6-14-29.6-38.3-44-5.2-3-10.8-6-16.8-8.9-16-7.6-22.8-26.6-15.2-42.5 7.6-16 26.6-22.8 42.5-15.2 7.7 3.7 15.1 7.6 22 11.6 57.6 34 69.8 72.7 69.8 99 0 45.9-36 86.8-101.5 115.1-57.4 24.6-132.2 38.2-211.7 38.2z'
              })
            ),
            props.secondaryLocation
          )
        )
      ),
      _react2.default.createElement(
        _next.Form.Item,
        _extends({}, props, {
          required: false,
          label: addressDetail ? addressDetail : ' ',
          hidden: !props.hasSelect
        }),
        _react2.default.createElement(
          _next.Grid.Row,
          { gutter: '4' },
          _react2.default.createElement(
            _next.Grid.Col,
            null,
            _react2.default.createElement(_next.Input, {
              name: 'doorPlate',
              placeholder: '\u95E8\u724C',
              value: props.doorPlate,
              onChange: function onChange(value) {
                _this4.detailChange('doorPlate', value);
              },
              style: { width: 120 }
            })
          ),
          _react2.default.createElement(
            _next.Grid.Col,
            null,
            _react2.default.createElement(_next.Input, {
              name: 'seat',
              placeholder: '\u671F\u5EA7',
              value: props.seat,
              onChange: function onChange(value) {
                _this4.detailChange('seat', value);
              },
              style: { width: 120 }
            })
          ),
          _react2.default.createElement(
            _next.Grid.Col,
            null,
            _react2.default.createElement(_next.Input, {
              name: 'floor',
              placeholder: '\u697C\u5C42',
              value: props.floor,
              onChange: function onChange(value) {
                _this4.detailChange('floor', value);
              },
              style: { width: 120 }
            })
          ),
          _react2.default.createElement(
            _next.Grid.Col,
            null,
            _react2.default.createElement(_next.Input, {
              name: 'unit',
              placeholder: '\u5355\u4F4D',
              value: props.unit,
              onChange: function onChange(value) {
                _this4.detailChange('unit', value);
              },
              style: { width: 120 }
            })
          )
        )
      )
    );
  };

  return AddressSelectMacao;
}(_react2.default.Component);

var AddressSelectOther = function (_React$Component4) {
  _inherits(AddressSelectOther, _React$Component4);

  function AddressSelectOther(props) {
    _classCallCheck(this, AddressSelectOther);

    var _this5 = _possibleConstructorReturn(this, _React$Component4.call(this, props));

    _this5.detailChange = _this5.detailChange.bind(_this5);
    return _this5;
  }

  AddressSelectOther.prototype.detailChange = function detailChange(type, value) {
    this.props.onEditData({ type: type, value: value });
  };

  AddressSelectOther.prototype.render = function render() {
    var _this6 = this;

    var props = this.props.props;
    var addressArea = props.addressArea,
        addressDetail = props.addressDetail;

    return _react2.default.createElement(
      _react.Fragment,
      null,
      _react2.default.createElement(
        _next.Grid.Row,
        { gutter: '4' },
        _react2.default.createElement(
          _next.Form.Item,
          _extends({
            className: 'next-form-address-text'
          }, _extends({}, props, {
            required: addressArea ? props.required : false,
            label: addressArea ? addressArea : ' '
          })),
          _react2.default.createElement(_next.Input, {
            name: 'countries',
            placeholder: '\u56FD\u5BB6',
            trim: true,
            value: props.countries,
            onChange: function onChange(value) {
              _this6.detailChange('countries', value);
            }
          })
        ),
        _react2.default.createElement(
          _next.Form.Item,
          { hidden: props.isMainlandDefault, className: 'next-form-address-text  vc-form-item' },
          _react2.default.createElement(_next.Input, {
            name: 'provinces',
            placeholder: '\u7701\u5E02\u533A',
            trim: true,
            value: props.provinces,
            onChange: function onChange(value) {
              _this6.detailChange('provinces', value);
            }
          })
        )
      ),
      _react2.default.createElement(
        _next.Form.Item,
        _extends({}, props, {
          required: false,
          help: undefined,
          validateState: null,
          label: addressDetail ? addressDetail : ' ',
          hidden: props.isMainlandDefault
        }),
        _react2.default.createElement(_next.Input, {
          name: 'detailAddress',
          placeholder: '\u8BF7\u8F93\u5165\u8BE6\u7EC6\u4FE1\u606F\u95E8\u724C\u53F7\u7B49',
          trim: true,
          value: props.detailAddress,
          onChange: function onChange(value) {
            _this6.detailChange('detailAddress', value);
          }
        })
      )
    );
  };

  return AddressSelectOther;
}(_react2.default.Component);

var AddressMacao = (_temp = _class2 = function (_Field) {
  _inherits(AddressMacao, _Field);

  function AddressMacao(props) {
    _classCallCheck(this, AddressMacao);

    var _this7 = _possibleConstructorReturn(this, _Field.call(this, props));

    _this7.state = {
      doorPlate: '',
      seat: '',
      unit: '',
      floor: '',
      address: props.fieldData.value || '',
      hasSelect: false, // 是否已经选中地址
      secondaryLocation: '',
      countries: '',
      provinces: '',
      detailAddress: '',
      area: 'macao',
      isMainlandDefault: false
    };
    if (props.fieldData.value && props.fieldData.value.indexOf('--') > -1) {
      _this7.state.area = 'mainland';
      _this7.state.isMainlandDefault = true;
      _this7.state.countries = props.fieldData.value;
    }
    _this7.onEditData = _this7.onEditData.bind(_this7);
    _this7.onSelectAdrress = _this7.onSelectAdrress.bind(_this7);
    _this7.onadressChange = _this7.onadressChange.bind(_this7);
    _this7.onChangeArea = _this7.onChangeArea.bind(_this7);
    return _this7;
  }

  AddressMacao.prototype.getFormItemProps = function getFormItemProps() {
    var oldProps = _Field.prototype.getFormItemProps.call(this);
    var commonProps = this.getControlProps();
    var _state = this.state,
        doorPlate = _state.doorPlate,
        seat = _state.seat,
        unit = _state.unit,
        floor = _state.floor,
        hasSelect = _state.hasSelect,
        secondaryLocation = _state.secondaryLocation,
        countries = _state.countries,
        provinces = _state.provinces,
        detailAddress = _state.detailAddress,
        address = _state.address,
        area = _state.area,
        isMainlandDefault = _state.isMainlandDefault;

    var props = this.getProps();
    var _props$addressArea = props.addressArea,
        addressArea = _props$addressArea === undefined ? '居住地址' : _props$addressArea,
        _props$addressDetail = props.addressDetail,
        addressDetail = _props$addressDetail === undefined ? '详细地址' : _props$addressDetail;

    var ret = _extends({}, oldProps, {
      area: area,
      doorPlate: doorPlate,
      address: address,
      countries: countries,
      provinces: provinces,
      detailAddress: detailAddress,
      seat: seat,
      floor: floor,
      unit: unit,
      hasSelect: hasSelect,
      secondaryLocation: secondaryLocation,
      isMainlandDefault: isMainlandDefault,
      addressArea: addressArea,
      addressDetail: addressDetail
    });
    return ret;
  };

  AddressMacao.prototype.getProps = function getProps() {
    return _extends({}, this.props, {
      fieldClassName: 'vc-address-macao'
    });
  };

  AddressMacao.prototype.onEditData = function onEditData() {
    var _setState;

    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    this.setState((_setState = {}, _defineProperty(_setState, value.type, value.value), _defineProperty(_setState, 'isMainlandDefault', false), _setState));
    this.onadressChange(_defineProperty({}, value.type, value.value));
  };

  AddressMacao.prototype.onSelectAdrress = function onSelectAdrress() {
    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    this.setState({ address: value.address, secondaryLocation: value.secondaryLocation, hasSelect: value.hasSelect });
    this.onadressChange({
      address: value.address,
      secondaryLocation: value.secondaryLocation,
      hasSelect: value.hasSelect
    });
    // this.setState,205({ [value.type]: value.value })
  };

  AddressMacao.prototype.onadressChange = function onadressChange() {
    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var onFieldChange = this.props.onFieldChange;

    var newState = _extends({}, this.state, value);
    var address = newState.address,
        doorPlate = newState.doorPlate,
        seat = newState.seat,
        floor = newState.floor,
        unit = newState.unit,
        countries = newState.countries,
        provinces = newState.provinces,
        detailAddress = newState.detailAddress,
        secondaryLocation = newState.secondaryLocation;

    if (this.state.area == 'macao' && !value.area || value.area && value.area === 'macao') {
      onFieldChange({ value: '' + secondaryLocation + address + doorPlate + seat + floor + unit });
    } else {
      onFieldChange({
        value: '' + countries + (provinces ? '--' : '') + provinces + (detailAddress ? '--' : '') + detailAddress
      });
    }
  };

  AddressMacao.prototype.onChangeArea = function onChangeArea() {
    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    this.setState({ area: value.value });
    this.onadressChange({ area: value.value });
  };

  AddressMacao.prototype.render = function render() {
    var props = void 0;
    if (window.VisualEngine) {
      props = this.getVeFormItemProps();
    } else {
      props = this.getFormItemProps();
    }
    var behavior = this.getBehavior();
    var formControl = _extends({}, props, {
      help: undefined,
      validateState: null,
      behavior: behavior
    });
    var _props = props,
        address = _props.address,
        area = _props.area,
        addressArea = _props.addressArea;

    return _react2.default.createElement(
      _react.Fragment,
      null,
      behavior === 'READONLY' ? _react2.default.createElement(
        _react.Fragment,
        null,
        _react2.default.createElement(
          _next.Form.Item,
          props,
          _react2.default.createElement(
            'div',
            { className: 'vc-form-item-view' },
            _react2.default.createElement(
              'span',
              { className: 'vc-form-item-view-text', title: listMap[area] },
              (0, _lodash.isNil)(listMap[area]) ? _formFieldUtils.EMPTY_TEXT : listMap[area]
            )
          )
        ),
        _react2.default.createElement(
          _next.Form.Item,
          _extends({}, props, { label: addressArea ? addressArea : ' ' }),
          _react2.default.createElement(
            'div',
            { className: 'vc-form-item-view' },
            _react2.default.createElement(
              'span',
              { className: 'vc-form-item-view-text', title: address },
              (0, _lodash.isNil)(address) ? _formFieldUtils.EMPTY_TEXT : address
            )
          )
        )
      ) : _react2.default.createElement(
        _react.Fragment,
        null,
        _react2.default.createElement(
          _next.Form.Item,
          formControl,
          _react2.default.createElement(ControlApp, { props: formControl, onChangeArea: this.onChangeArea })
        ),
        props.area === 'macao' ? _react2.default.createElement(AddressSelectMacao, { onSelectAdrress: this.onSelectAdrress, onEditData: this.onEditData, props: props }) : _react2.default.createElement(AddressSelectOther, { onEditData: this.onEditData, props: props })
      )
    );
  };

  return AddressMacao;
}(_vuFusionField2.default), _class2.displayName = 'AddressMacao', _class2.defaultProps = _extends({}, _vuFusionField2.default.defaultProps, {
  fieldId: null,
  label: null
}), _class2.propTypes = {
  fieldId: _propTypes2.default.string,
  label: _propTypes2.default.string
}, _class2.mutableStates = [].concat(_toConsumableArray(_vuFusionField2.default.mutableStates), [{
  name: 'fieldData',
  formatIn: function formatIn(fieldData, props) {
    var fieldDataOld = props.getValue('fieldData');
    return fieldDataOld;
  }
}]), _class2.validators = {
  required: {
    valid: function valid(value) {
      return value;
    },
    defaultMessage: {
      en_US: 'this field cannot be empty',
      zh_CN: '当前字段不能为空'
    }
  }
}, _class2.defaultMutators = _extends({}, _vuFusionField2.default.defaultMutators, {
  onFieldChange: function onFieldChange(_ref, fieldData) {
    var state = _ref.state;

    if (fieldData && fieldData.hasOwnProperty('value') && (0, _lodash.isEmpty)(fieldData.value)) {
      // fieldData.value 为空时无法赋值
      state.setVal(fieldData.value);
    }
    state.merge('fieldData', _extends({}, fieldData, {
      dataType: 'CHANGED'
    }));
  }
}), _temp);
exports.default = AddressMacao;
module.exports = exports['default'];